import WalletCard from "../HistoryCard/WalletCard";
import { useAppSelector } from "../../../../../app/hooks";
import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import { GetCurrencyFixedToTwo } from "../../../../../utils/commonFunctions/GetCurrencyFixedToTwo";
import { format } from "date-fns";
import _ from "lodash";
import DropDownMenu from "../../../../widgets/DropDownMenu/DropDownMenu";
import { CardTypes } from "../../../../../enums";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const T3_TransactionHistory = (props: any) => {
  const { less_icon, greater_icon, no_data_img, card_type } = props.content;

  const { date, amount, card, no_transaction } = props.content.wh_data;

  const {
    userList,
    handleLineItemClick,
    handleLineClose,
    lineAnchorEl,
    handleClickLineItem,
    selectedLineIndex,
    lineOpen,
    toggleButtonText,
    handleViewMoreClick,
    walletuserData,
    getStartAndEndDateData,
    newFilteredData,
    itemsToShow,
    formatDate,
  } = props;
  const { getTransactionHistoryPending } = useAppSelector(
    (state) => state?.services
  );
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "end" },
        }}
      >
        <DropDownMenu
          statuslist={userList}
          handleMenuItemClick={handleLineItemClick}
          handleClose={handleLineClose}
          menuAnchorEl={lineAnchorEl}
          handleClickListItem={handleClickLineItem}
          selectedIndex={selectedLineIndex}
          menuOpen={lineOpen}
          selectedIcon={props.content.select_img}
          uparrowIcon={props.content.up_arrow_img}
          downarrowIcon={props.content.down_arrow_img}
          styleSX={{
            backgroundColor: "transparent !important",
            "& .MuiListItemText-secondary": {
              color: "var(--text_color) !important",
              fontSize: "16px !important",
              linHeight: "28px !important",
              fontWeight: "var(--font_weight_1) !important",
              fontFamily: "var(--font_family_Medium) !important",
            },
            "& .MuiList-root": {
              padding: { xs: "0px", sm: "0px 8px" },
            },
          }}
        />
      </Box>
      {walletuserData ? (
        <WalletCard lineDataForWallet={walletuserData} content={props.content}>
          {!getTransactionHistoryPending ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              {newFilteredData?.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    mt: "20px",
                  }}
                >
                  {/* <Box
                   
                  > */}
                  {/* <img
                      style={{ cursor: "pointer" }}
                      src={less_icon.data.attributes.url}
                      alt={less_icon.data.attributes.alternativeText}
                    /> */}
                  <ArrowBackIosIcon
                    fontSize="small"
                    style={{
                      color: "var(--primary_color)",
                      fontSize: "1.125rem",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (
                        getStartAndEndDateData.totalNumberOfKeys > 0 &&
                        props.selectedDateKeyIndex > 0
                      ) {
                        props.handleBillCycleChange("decrement");
                      }
                    }}
                  />
                  {/* </Box> */}
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "var(--font_weight_1)",
                      fontFamily: "var(--font_family_Medium)",
                    }}
                  >
                    {getStartAndEndDateData?.displayStartDate
                      ? format(
                          new Date(getStartAndEndDateData.displayStartDate),
                          "MMM dd, yyyy"
                        )
                      : null}
                  </Typography>
                  <span>-</span>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "var(--font_weight_1)",
                      fontFamily: "var(--font_family_Medium)",
                    }}
                  >
                    {getStartAndEndDateData?.displayEndDate
                      ? format(
                          new Date(getStartAndEndDateData.displayEndDate),
                          "MMM dd, yyyy"
                        )
                      : null}
                  </Typography>
                  {/* <Box
                   
                  > */}
                  {/* <img
                      style={{ cursor: "pointer" }}
                      src={greater_icon.data.attributes.url}
                      alt={greater_icon.data.attributes.alternativeText}
                    /> */}
                  <ArrowForwardIosIcon
                    fontSize="small"
                    style={{
                      color: "var(--primary_color)",
                      fontSize: "1.125rem",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (
                        getStartAndEndDateData.totalNumberOfKeys > 0 &&
                        props.selectedDateKeyIndex !==
                          getStartAndEndDateData.totalNumberOfKeys - 1
                      ) {
                        props.handleBillCycleChange("increment");
                      }
                    }}
                  />
                  {/* </Box> */}
                </Box>
              )}
              {newFilteredData?.length === 0 && (
                <Box sx={{ padding: { xs: "20px", sm: "80px" } }}>
                  <Box
                    component="img"
                    src={no_data_img.data.attributes?.url}
                    alt={no_data_img.data.attributes.alternativeText}
                  />
                  <Typography
                    sx={{
                      fontSize: { xs: "24px", sm: "34px" },
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_5)",
                      opacity: 0.4,
                    }}
                  >
                    {no_transaction}
                  </Typography>
                </Box>
              )}
              {newFilteredData?.length !== 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: { xs: "100%", md: "85%" },
                    margin: "auto",
                  }}
                >
                  <Typography
                    sx={{
                      flex: "1", // Allow the first column to grow
                      fontSize: "14px",
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_5)",
                    }}
                  >
                    {date}
                  </Typography>
                  <Typography
                    sx={{
                      flex: "1",
                      fontSize: "14px",
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_5)",
                    }}
                  >
                    {amount}
                  </Typography>
                  <Typography
                    sx={{
                      flex: "1",
                      fontSize: "14px",
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_5)",
                    }}
                  >
                    {card}
                  </Typography>
                </Box>
              ) : null}
              {_.orderBy(newFilteredData, ["purchaseDate"], ["desc"])
                ?.slice(0, itemsToShow)
                .map((data: any) => (
                  <Box
                    key={data.uuid}
                    sx={{
                      flex: "1",
                      display: "flex",
                      justifyContent: "space-between",
                      width: { xs: "100%", md: "85%" },
                      margin: "auto",
                    }}
                  >
                    <Typography
                      sx={{
                        flex: "1", // Allow the first column to grow
                        fontSize: "14px",
                        fontFamily: "var(--font_family_Medium)",
                        fontWeight: "var(--font_weight_1)",
                      }}
                    >
                      {formatDate(data.purchaseDate)}
                    </Typography>
                    <Typography
                      sx={{
                        flex: "1",
                        fontSize: "14px",
                        fontFamily: "var(--font_family_Medium)",
                        fontWeight: "var(--font_weight_1)",
                      }}
                    >
                      {GetCurrencyFixedToTwo(data.purchasedCredit)}
                    </Typography>
                    <Typography
                      sx={{
                        flex: "1",
                        fontSize: "14px",
                        fontFamily: "var(--font_family_Medium)",
                        fontWeight: "var(--font_weight_1)",
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        component="img"
                        src={
                          data.cardType?.toUpperCase() === CardTypes?.VISA
                            ? card_type?.data[0]?.attributes?.url
                            : data.cardType?.toUpperCase() ===
                              CardTypes?.DISCOVER
                            ? card_type?.data[1]?.attributes?.url
                            : data.cardType?.toUpperCase() ===
                              CardTypes?.AMERICANEXPRESS
                            ? card_type?.data[2]?.attributes?.url
                            : data.cardType?.type?.toUpperCase() ===
                              CardTypes?.MASTERCARD
                            ? card_type?.data[3]?.attributes?.url
                            : card_type?.data[0]?.attributes?.url
                        }
                        alt={card_type?.data[0].attributes.alternativeText}
                        width={26}
                        height={16}
                      />
                      xx
                      {data.ccNumberMask}
                    </Typography>
                  </Box>
                ))}

              {newFilteredData?.length > 3 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    onClick={handleViewMoreClick}
                    sx={{
                      fontSize: "16px",
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_5)",
                      cursor: "pointer",
                      marginBottom: "5px",
                      color: "var(--primary_color)",
                    }}
                  >
                    {toggleButtonText()}
                  </Typography>
                </Box>
              )}
            </Box>
          ) : (
            <Box textAlign={"center"}>
              <CircularProgress sx={{ color: "var(--primary_color)" }} />
            </Box>
          )}
        </WalletCard>
      ) : (
        <Box textAlign={"center"}>
          <CircularProgress sx={{ color: "var(--primary_color)" }} />
        </Box>
      )}
    </>
  );
};

export default T3_TransactionHistory;
